import { ConfirmationStage, EnterDetailsStage, SelectParentStage } from "./stages";
import { CreatePartitionRequest, UpdatePartitionCallOffCodeRequest, createPartition, updatePartitionCallOffCode } from "domains/partitions/services/partition-service";
import Wizard, { WizardStep } from "features/common/Wizard";
import { useCallback, useState } from "react";

import { IntroStage } from "features/common/stages";
import localisations from "../../localisation";

type CreatePartitionFeatureProps = {
    fieldCompanyId: number;
};

export default function CreatePartitionFeature(props: CreatePartitionFeatureProps) {
    const [fields, setFields] = useState({} as any);
    const { intro, selectParent, enterDetails, confirmation } = localisations.createPartition.stepper;

    const handleFieldChange = useCallback((newFields: any) => setFields((x:any) => ({ ...x, ...newFields })), [setFields]);

    const createPartitionFromFeatureFields = async () => {
        let request = {
            fieldCompanyId: props.fieldCompanyId,
            parentHierarchyNodeId: fields.parentHierarchyNodeId,
            name: fields.name,
            reference: fields.reference,
            ownerEmail: fields.emailAddress,
            notes: fields.notes,
        } as CreatePartitionRequest;

        const partition = await createPartition(request);

        if (fields.callOffCodes) {
            try {
                await updatePartitionCallOffCode(partition.id, { callOffCodes: fields.callOffCodes } as UpdatePartitionCallOffCodeRequest);
            }
            catch {
                alert("Unable to update the Call Off Code.");
            }
        }
        
        return true;
    };

    const steps = [
        {
            label: intro,
            component: <IntroStage localisations={localisations.createPartition.stages.intro} />
        },
        {
            label: selectParent,
            component: <SelectParentStage fieldCompanyId={props.fieldCompanyId} fields={fields} handleFieldChange={handleFieldChange} />,
            onNext: () => { return fields.parentHierarchyNodeId; }
        },
        {
            label: enterDetails,
            component: <EnterDetailsStage fields={fields} handleFieldChange={handleFieldChange} />
        },        {
            label: confirmation,
            component: <ConfirmationStage fields={fields} />,
            onNext: createPartitionFromFeatureFields
        },
    ] as WizardStep[];

    return (
        <Wizard
            fieldCompanyId={props.fieldCompanyId}
            steps={steps}
            resultStageLocalisations={localisations.createPartition.stages.result}
            serverErrorLocalisations={localisations.createPartition.serverErrors}
        />
    );
}
